<template>
  <div class="fills-list">
    <article
      v-for="item in safeItems"
      :key="item.id"
      class="fill-row"
      :class="{ 'is-unread': isUnread(item) }"
    >
      <div class="fill-row-main">
        <span v-if="isUnread(item)" class="unread-dot" aria-hidden="true"></span>
        <span class="form-id-chip">#{{ item.id }}</span>
        <div class="fill-user">
          <div class="fill-user-name">
            <template v-if="item.user">
              {{ item.user.name }} {{ item.user.last_name }}
              <router-link target="_blank" class="fill-profile-link"
                           :to="{ name: 'UpdateUser', params: { id: item.user.id } }">
                (پروفایل)
              </router-link>
            </template>
            <span v-else class="text-muted">کاربر مهمان</span>
          </div>
          <div class="fill-user-sub">
            <span v-if="item.user && item.user.cellphone" dir="ltr">{{ item.user.cellphone }}</span>
            <span v-if="item.form">{{ item.form.name }}</span>
          </div>
        </div>
      </div>

      <div class="fill-row-meta">
        <span v-if="isUnread(item)" class="fill-chip is-new">جدید</span>
        <span class="fill-chip" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
        <span v-if="item.score !== null && item.score !== undefined && item.score !== ''" class="fill-chip is-score">
          امتیاز: {{ item.score }}
        </span>
        <span class="fill-date" dir="ltr">{{ dateConverter(item.created_at, '/', true) }}</span>
      </div>

      <router-link
        v-if="item.user"
        target="_blank"
        class="form-action is-main fill-open"
        :to="{ name: 'FormAnswer', params: { form_fill: item.id, user: item.user.id } }"
        @click.native="$emit('open', item)"
      >
        <b-icon icon="archive-fill"></b-icon>
        <span>مشاهده پاسخ</span>
      </router-link>
    </article>
  </div>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "./forms-ui.css";

const STATUS_LABELS = {
  0: 'در انتظار بررسی ادمین',
  3: 'تکمیل شده',
}

export default {
  name: "FormTableItems",
  props: {
    items: {
      default: () => []
    },
    showSeenState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    safeItems() {
      return Array.isArray(this.items) ? this.items : []
    }
  },
  methods: {
    dateConverter,
    isUnread(item) {
      return this.showSeenState && Boolean(item && item.is_new)
    },
    statusLabel(status) {
      const key = Number(status)
      return STATUS_LABELS[key] !== undefined ? STATUS_LABELS[key] : `وضعیت ${status}`
    },
    statusClass(status) {
      const key = Number(status)
      if (key === 0) {
        return 'is-waiting'
      }
      if (key === 3) {
        return 'is-done'
      }
      return 'is-other'
    }
  }
}
</script>
